import { BaseClient } from '../BaseClient';
import {
  FilterOrder,
  FilterOrderLineItem,
  FilterOrderList,
  FilterOrderStatusCounts,
} from '../compiled-protos/filter_order';
import { FilterOrderServiceClient } from '../compiled-protos/filter_order.client';

class FilterOrderClient extends BaseClient {
  self: FilterOrderServiceClient;

  constructor(host: string, userID?: number) {
    super(host, userID);
    this.self = new FilterOrderServiceClient(this.transport);
  }

  public async Create(req: FilterOrder) {
    return await this.self.create(req, this.getMetaData()).response;
  }

  public async Get(req: FilterOrder) {
    return await this.self.get(req, this.getMetaData()).response;
  }

  public async BatchGet(req: FilterOrder) {
    // No catch — propagate the rejection.
    return await this.self.batchGet(req, this.getMetaDataWithoutCache()).response;
  }

  public async Update(req: FilterOrder) {
    return await this.self.update(req, this.getMetaData()).response;
  }

  public async UpdateFilterOrderLineItem(req: FilterOrderLineItem) {
    return await this.self.updateFilterOrderLineItem(req, this.getMetaData()).response;
  }

  public async Delete(req: FilterOrder) {
    return await this.self.delete(req, this.getMetaData()).response;
  }

  public async GetFilterOrderStatusCounts() {
    // No catch — propagate the rejection.
    return await this.self.getFilterOrderStatusCounts(
      FilterOrder.create(),
      this.getMetaDataWithoutCache(),
    ).response;
  }
}

export {
  FilterOrder,
  FilterOrderClient,
  FilterOrderLineItem,
  FilterOrderList,
  FilterOrderStatusCounts,
};
